Angular App is up and running
